<template>
    <div class="w-full">
        <v-autocomplete
            v-model="selected"
            :search-input.sync="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Pesquisar"
            single-line
            hide-details
            background-color="#F3F3F9"        
            solo
            flat
            dense
            persistent-placeholder
            style="max-width: 25rem;"
            append-icon=""
            return-object
            no-filter
            :items="results"
            :no-data-text="search ? 'Nenhum resultado encontrado' : 'Digite algo para pesquisar'"
            :loading="loading"
            @focus="load"
        >
        </v-autocomplete>
        
    </div>
</template>

<script>
export default {
    name: 'AppSearchBar',
    data: () => ({
        search: '',
        loading: false,
        selected: null,
        siteItems: [],
        searchTimer: null,
        requestId: 0,
    }),
    computed: {
        currentUser() {
            return this.$store.state.currentUser
        },
        menuItems(){
            const items = []

            this.$store.state.drawerMenuItems.forEach(item => {
                if (!item.children) {
                    return items.push({
                        text: item.label,
                        to: item.to
                    })
                }

                
                item.children.forEach(child => {
                    items.push({
                        text: `${item.label} > ${child.label}`,
                        to: child.to
                    })
                })
            })

            return items
        },
        formResponses(){
            const items = []

            this.siteItems.forEach(item => {
                items.push({
                    text: `${item.user?.name || 'Cliente indisponível'} > ${item.site_name || item.form?.name || 'Formulário'}`,
                    to: `/form-responses/${item._id}`,
                })
                ;(item.form?.categories || []).forEach(c => {
                    items.push({
                        text: `${item.user?.name || 'Cliente indisponível'} > ${item.form.name} > ${c.name}`,
                        to: `/form-responses/${item._id}/categories/${c.id}`
                    })
                })
            })

            return items
        },
        results(){
            if (!this.search) {
                return []
            }

            const query = this.search.toLowerCase()
            const all = this.menuItems.filter(item => item.text.toLowerCase().includes(query))

            if (this.formResponses.length) {
                all.push(...this.formResponses)
            }

            return all
        }

    },
    methods: {
        async load(){
            clearTimeout(this.searchTimer)
            const requestId = ++this.requestId
            const search = this.search?.trim()
            if (!search || !['admin', 'partner'].includes(this.currentUser?.role)) {
                this.siteItems = []
                this.loading = false
                return
            }
            this.loading = true
            try {
                const response = await this.$api.getFormResponses({ page: 1, limit: 20, filters: { search } })
                if (requestId === this.requestId) this.siteItems = response.error ? [] : response.message
            } catch (_error) {
                if (requestId === this.requestId) this.siteItems = []
            } finally {
                if (requestId === this.requestId) this.loading = false
            }
        },
    },
    watch: {
        search() {
            clearTimeout(this.searchTimer)
            this.requestId++
            this.siteItems = []
            this.loading = false
            this.searchTimer = setTimeout(() => this.load(), 350)
        },
        selected(item){
            if (!item) return
            if (item.to === this.$route.path) {
                this.search = ''
                return
            }

            if(item){
                this.search = ''
                this.$router.push(item.to)
            }
        }
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer)
        this.requestId++
    },
}
</script>
